import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./ReportCRUD";
import { reportSlice } from "./ReportSlice";

const { actions } = reportSlice;

export const clearWinLoseDetail = () => (dispatch) => {
  dispatch(actions.clearWinLoseDetail());
};

export const clearPromotionReport = () => (dispatch) => {
  dispatch(actions.clearPromotionReport());
};

export const getWinLoseDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.DETAIL }));

  return requestToApi
    .postAgent17(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.winLoseDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getWinLoseDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.DETAIL })
      );
      throw error;
    });
};

export const fetchPromotionReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent17(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionReportFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getPromotionReport");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const callAgentReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.agentReportFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkReportList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const agentDownlineReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
  dispatch(actions.agentDownlineReportFetch({ data: null }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.agentDownlineReportFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkReportList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const agentDownlineDetails = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.agentDownlineDetailsFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkReportList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const transactionReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkReportList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.transactionReportFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: checkReportList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callSummaryReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent12(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.summaryReportFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: summaryReportFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const agentDownlineMemberReport = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkDetailsReportList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.agentDownlineMemberReportFetch({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: agentDownlineMemberDetails");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callAgentDownlineMemberDetails = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .checkReportList(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.agentDownlineMemberDetailsFetch({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: callAgentDownlineMemberDetails");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const fetchMemberSummaryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberSummaryDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchMemberSummaryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const fetchGameSummaryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.gameSummaryDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchGameSummaryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
